import { Tabs, Button } from "@heroui/react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import type { PeriodFormat } from "../model/types";

export interface StatisticsPeriodSelectorProps {
  title: string;
  format: PeriodFormat;
  onFormatChange: (format: PeriodFormat) => void;
  onPrev: () => void;
  onNext: () => void;
  isNextDisabled?: boolean;
  isPrevDisabled?: boolean;
}

export const StatisticsPeriodSelector = ({
  title,
  format,
  onFormatChange,
  onPrev,
  onNext,
  isNextDisabled = false,
  isPrevDisabled = false,
}: StatisticsPeriodSelectorProps) => {
  return (
    <div className="flex flex-col sm:flex-row items-center justify-between gap-3 w-full">
      {/* Быстрые стрелочки переключения и заголовок текущего периода */}
      <div className="flex items-center gap-2">
        <Button
          variant="ghost"
          size="sm"
          isIconOnly
          aria-label="Предыдущий период"
          onPress={onPrev}
          isDisabled={isPrevDisabled}
        >
          <ChevronLeft className="w-4 h-4" />
        </Button>

        <span className="text-base font-semibold min-w-[200px] text-center select-none">
          {title}
        </span>

        <Button
          variant="ghost"
          size="sm"
          isIconOnly
          aria-label="Следующий период"
          onPress={onNext}
          isDisabled={isNextDisabled}
        >
          <ChevronRight className="w-4 h-4" />
        </Button>
      </div>

      {/* Выбор формата отображения через HeroUI Tabs */}
      <Tabs
        selectedKey={format}
        onSelectionChange={(key) => onFormatChange(key as PeriodFormat)}
      >
        <Tabs.ListContainer>
          <Tabs.List aria-label="Формат отображения">
            <Tabs.Tab id="week">
              Неделя
              <Tabs.Indicator />
            </Tabs.Tab>
            <Tabs.Tab id="month">
              Месяц
              <Tabs.Indicator />
            </Tabs.Tab>
            <Tabs.Tab id="year">
              Год
              <Tabs.Indicator />
            </Tabs.Tab>
          </Tabs.List>
        </Tabs.ListContainer>
      </Tabs>
    </div>
  );
};
